<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Manage Payroll</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item active" aria-current="page">Manage Payroll</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2"></div>
  </div>
  <!-- /Breadcrumb -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <div class="d-flex my-xl-auto align-items-center flex-wrap row-gap-3">
        <div class="dropdown me-3">
          <select id="financialYear" [formControl]="selectedFinancialYear" class="form-select">
            <option value="" selected disabled>Select Financial Year</option>
            <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
          </select>
        </div>

        <div class="dropdown me-3">
          <select class="form-select" [formControl]="selectedBusiness">
            <option value="" selected disabled>Select Business Entity</option>
            <option *ngFor="let item of businessesList" [value]="item.id">
              {{ item.businessName | capitalize }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="accordion" id="accordionPayroll">
    <div *ngIf="visibleQuarters.has('Q4')" class="accordion-item mb-3">
      <h2 class="accordion-header" id="headingFour">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseFour"
          aria-expanded="false"
          aria-controls="collapseFour"
          [attr.aria-expanded]="currentQuarter === 'Q4'"
          [class.collapsed]="currentQuarter !== 'Q4'"
        >
          Q4, January - March
        </button>
      </h2>
      <div
        id="collapseFour"
        class="accordion-collapse collapse"
        aria-labelledby="headingFour"
        data-bs-parent="#accordionPayroll"
        [class.show]="currentQuarter === 'Q4'"
      >
        <div class="accordion-body d-flex">
          <div *ngFor="let batch of payrollDataByQuarter.Q4" class="card mx-3 payroll-card">
            <ng-container *ngIf="batch.status === PayrollStatus.PENDING; else elseBlock">
              <div class="card-body">
                <p>Payroll for the period:</p>
                <h6 class="card-title fw-semibold mb-2">
                  {{ batch.payPeriodStart | date: 'dd MMM' }} -
                  {{ batch.payPeriodEnd | date: 'dd MMM' }}
                </h6>
                <div class="d-flex align-items-center pending-card-body">
                  <button class="btn btn-primary" (click)="setupRunningPayroll(batch)">
                    Run Payroll
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #elseBlock>
              <div class="card-body">
                <h6 class="card-title fw-semibold mb-4">
                  <ng-container
                    *ngIf="
                      batch.status === PayrollStatus.PROCESSED ||
                        batch.status === PayrollStatus.PAID;
                      else elseBlock
                    "
                  >
                    <button (click)="setupRunningPayroll(batch)" class="nav-link">
                      {{ batch.payPeriodStart | date: 'dd MMM' }} -
                      {{ batch.payPeriodEnd | date: 'dd MMM' }}
                    </button>
                  </ng-container>
                  <ng-template #elseBlock>
                    {{ batch.payPeriodStart | date: 'dd MMM' }} -
                    {{ batch.payPeriodEnd | date: 'dd MMM' }}
                  </ng-template>
                </h6>
                <p class="card-subtitle mb-4 text-muted">
                  <span class="badge bg-soft-info">{{ batch.status | titlecase }}</span>
                  <button
                    (click)="setupRunningPayroll(batch, true)"
                    *ngIf="
                      !(
                        batch.status === PayrollStatus.PENDING ||
                        batch.status === PayrollStatus.PAID
                      )
                    "
                    class="ms-2 btn btn-outline-primary"
                  >
                    {{ batch.status === PayrollStatus.PROCESSED ? 'Paid ?' : 'Confirm' }}
                  </button>
                </p>
                <div>
                  <h6>Net Salary</h6>
                  <p>{{ batch.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</p>
                </div>
                <p class="card-text pt-2">
                  Processed on {{ batch.updatedAt | date: 'MMM dd yyyy, H:mm:ss' }}
                </p>
              </div>
              <div class="card-footer d-flex justify-content-between">
                <button
                  class="btn btn-outline-info"
                  (click)="exportPayrollToCsv(batch)"
                  [disabled]="isExporting"
                >
                  <span *ngIf="!isExporting || exportingBatchId !== batch.id"
                    ><i class="ti ti-download"></i>Export</span
                  >
                  <span *ngIf="isExporting && exportingBatchId === batch.id"> Exporting...</span>
                </button>
                <button
                  (click)="openDeleteModal(deleteModal, batch?.id ?? '')"
                  class="btn btn-icon btn-danger"
                >
                  <i class="ti ti-trash"></i>
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visibleQuarters.has('Q3')" class="accordion-item mb-3">
      <h2 class="accordion-header" id="headingThree">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseThree"
          aria-expanded="false"
          aria-controls="collapseThree"
          [attr.aria-expanded]="currentQuarter === 'Q3'"
          [class.collapsed]="currentQuarter !== 'Q3'"
        >
          Q3, October - December
        </button>
      </h2>
      <div
        id="collapseThree"
        class="accordion-collapse collapse"
        aria-labelledby="headingThree"
        [class.show]="currentQuarter === 'Q3'"
        data-bs-parent="#accordionExample"
      >
        <div class="accordion-body d-flex">
          <div *ngFor="let batch of payrollDataByQuarter.Q3" class="card mx-3 payroll-card">
            <ng-container *ngIf="batch.status === PayrollStatus.PENDING; else elseBlock">
              <div class="card-body">
                <p>Payroll for the period:</p>
                <h6 class="card-title fw-semibold mb-2">
                  {{ batch.payPeriodStart | date: 'dd MMM' }} -
                  {{ batch.payPeriodEnd | date: 'dd MMM' }}
                </h6>
                <div class="d-flex align-items-center pending-card-body">
                  <button (click)="setupRunningPayroll(batch)" class="btn btn-primary">
                    Run Payroll
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #elseBlock>
              <div class="card-body">
                <h6 class="card-title fw-semibold mb-4">
                  <ng-container
                    *ngIf="
                      batch.status === PayrollStatus.PROCESSED ||
                        batch.status === PayrollStatus.PAID;
                      else elseBlock
                    "
                  >
                    <button (click)="setupRunningPayroll(batch)" class="nav-link">
                      {{ batch.payPeriodStart | date: 'dd MMM' }} -
                      {{ batch.payPeriodEnd | date: 'dd MMM' }}
                    </button>
                  </ng-container>
                  <ng-template #elseBlock>
                    {{ batch.payPeriodStart | date: 'dd MMM' }} -
                    {{ batch.payPeriodEnd | date: 'dd MMM' }}
                  </ng-template>
                </h6>
                <p class="card-subtitle mb-4 text-muted">
                  <span class="badge bg-soft-info">{{ batch.status | titlecase }}</span>
                  <button
                    (click)="setupRunningPayroll(batch, true)"
                    *ngIf="
                      !(
                        batch.status === PayrollStatus.PENDING ||
                        batch.status === PayrollStatus.PAID
                      )
                    "
                    class="ms-2 btn btn-outline-primary"
                  >
                    {{ batch.status === PayrollStatus.PROCESSED ? 'Paid ?' : 'Confirm' }}
                  </button>
                </p>
                <div>
                  <h6>Net Salary</h6>
                  <p>{{ batch.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</p>
                </div>
                <p class="card-text pt-2">
                  Processed on {{ batch.updatedAt | date: 'MMM dd yyyy, H:mm:ss' }}
                </p>
              </div>
              <div class="card-footer d-flex justify-content-between">
                <button
                  class="btn btn-outline-info"
                  (click)="exportPayrollToCsv(batch)"
                  [disabled]="isExporting"
                >
                  <span *ngIf="!isExporting || exportingBatchId !== batch.id"
                    ><i class="ti ti-download"></i>Export</span
                  >
                  <span *ngIf="isExporting && exportingBatchId === batch.id"> Exporting...</span>
                </button>
                <button
                  (click)="openDeleteModal(deleteModal, batch?.id ?? '')"
                  class="btn btn-icon btn-danger"
                >
                  <i class="ti ti-trash"></i>
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visibleQuarters.has('Q2')" class="accordion-item mb-3">
      <h2 class="accordion-header" id="headingTwo">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
          [attr.aria-expanded]="currentQuarter === 'Q2'"
          [class.collapsed]="currentQuarter !== 'Q2'"
        >
          Q2, July - September
        </button>
      </h2>
      <div
        id="collapseTwo"
        class="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
        [class.show]="currentQuarter === 'Q2'"
      >
        <div class="accordion-body d-flex">
          <div *ngFor="let batch of payrollDataByQuarter.Q2" class="card mx-3 payroll-card">
            <ng-container *ngIf="batch.status === PayrollStatus.PENDING; else elseBlock">
              <div class="card-body">
                <p>Payroll for the period:</p>
                <h6 class="card-title fw-semibold mb-2">
                  {{ batch.payPeriodStart | date: 'dd MMM' }} -
                  {{ batch.payPeriodEnd | date: 'dd MMM' }}
                </h6>
                <div class="d-flex align-items-center pending-card-body">
                  <button (click)="setupRunningPayroll(batch)" class="btn btn-primary">
                    Run Payroll
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #elseBlock>
              <div class="card-body">
                <h6 class="card-title fw-semibold mb-4">
                  <ng-container
                    *ngIf="
                      batch.status === PayrollStatus.PROCESSED ||
                        batch.status === PayrollStatus.PAID;
                      else elseBlock
                    "
                  >
                    <button (click)="setupRunningPayroll(batch)" class="nav-link">
                      {{ batch.payPeriodStart | date: 'dd MMM' }} -
                      {{ batch.payPeriodEnd | date: 'dd MMM' }}
                    </button>
                  </ng-container>
                  <ng-template #elseBlock>
                    {{ batch.payPeriodStart | date: 'dd MMM' }} -
                    {{ batch.payPeriodEnd | date: 'dd MMM' }}
                  </ng-template>
                </h6>
                <p class="card-subtitle mb-4 text-muted">
                  <span class="badge bg-soft-info">{{ batch.status | titlecase }}</span>
                  <button
                    (click)="setupRunningPayroll(batch, true)"
                    *ngIf="
                      !(
                        batch.status === PayrollStatus.PENDING ||
                        batch.status === PayrollStatus.PAID
                      )
                    "
                    class="ms-2 btn btn-outline-primary"
                  >
                    {{ batch.status === PayrollStatus.PROCESSED ? 'Paid ?' : 'Confirm' }}
                  </button>
                </p>
                <div>
                  <h6>Net Salary</h6>
                  <p>{{ batch.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</p>
                </div>
                <p class="card-text pt-2">
                  Processed on {{ batch.updatedAt | date: 'MMM dd yyyy, H:mm:ss' }}
                </p>
              </div>
              <div class="card-footer d-flex justify-content-between">
                <button
                  class="btn btn-outline-info"
                  (click)="exportPayrollToCsv(batch)"
                  [disabled]="isExporting"
                >
                  <span *ngIf="!isExporting || exportingBatchId !== batch.id"
                    ><i class="ti ti-download"></i>Export</span
                  >
                  <span *ngIf="isExporting && exportingBatchId === batch.id"> Exporting...</span>
                </button>
                <button
                  (click)="openDeleteModal(deleteModal, batch?.id ?? '')"
                  class="btn btn-icon btn-danger"
                >
                  <i class="ti ti-trash"></i>
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visibleQuarters.has('Q1')" class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
          [attr.aria-expanded]="currentQuarter === 'Q1'"
          [class.collapsed]="currentQuarter !== 'Q1'"
        >
          Q1, April - June
        </button>
      </h2>
      <div
        id="collapseOne"
        class="accordion-collapse collapse"
        [class.show]="currentQuarter === 'Q1'"
        aria-labelledby="headingOne"
        data-bs-parent="#accordionExample"
      >
        <div class="accordion-body d-flex">
          <div *ngFor="let batch of payrollDataByQuarter.Q1" class="card mx-3 payroll-card">
            <ng-container *ngIf="batch.status === PayrollStatus.PENDING; else elseBlock">
              <div class="card-body">
                <p>Payroll for the period:</p>
                <h6 class="card-title fw-semibold mb-2">
                  {{ batch.payPeriodStart | date: 'dd MMM' }} -
                  {{ batch.payPeriodEnd | date: 'dd MMM' }}
                </h6>
                <div class="d-flex align-items-center pending-card-body">
                  <button (click)="setupRunningPayroll(batch)" class="btn btn-primary">
                    Run Payroll
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #elseBlock>
              <div class="card-body">
                <h6 class="card-title fw-semibold mb-4">
                  <ng-container
                    *ngIf="
                      batch.status === PayrollStatus.PROCESSED ||
                        batch.status === PayrollStatus.PAID;
                      else elseBlock
                    "
                  >
                    <button (click)="setupRunningPayroll(batch)" class="nav-link">
                      {{ batch.payPeriodStart | date: 'dd MMM' }} -
                      {{ batch.payPeriodEnd | date: 'dd MMM' }}
                    </button>
                  </ng-container>
                  <ng-template #elseBlock>
                    {{ batch.payPeriodStart | date: 'dd MMM' }} -
                    {{ batch.payPeriodEnd | date: 'dd MMM' }}
                  </ng-template>
                </h6>
                <p class="card-subtitle mb-4 text-muted">
                  <span class="badge bg-soft-info">{{ batch.status | titlecase }}</span>
                  <button
                    (click)="setupRunningPayroll(batch, true)"
                    *ngIf="
                      !(
                        batch.status === PayrollStatus.PENDING ||
                        batch.status === PayrollStatus.PAID
                      )
                    "
                    class="ms-2 btn btn-outline-primary"
                  >
                    {{ batch.status === PayrollStatus.PROCESSED ? 'Paid ?' : 'Confirm' }}
                  </button>
                </p>
                <div>
                  <h6>Net Salary</h6>
                  <p>{{ batch.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</p>
                </div>
                <p
                  *ngIf="
                    batch.status === PayrollStatus.IN_PROCESS ||
                    batch.status === PayrollStatus.PROCESSED ||
                    batch.status === PayrollStatus.PAID
                  "
                  class="card-text pt-2 mb-0"
                >
                  Processed on {{ batch.processedOn | date: 'MMM dd yyyy, H:mm:ss' }}
                </p>
                <p *ngIf="batch.status === PayrollStatus.PAID" class="card-text">
                  Paid on {{ batch.dateOfPayment | date: 'MMM dd yyyy, H:mm:ss' }}
                </p>
              </div>
              <div class="card-footer d-flex justify-content-between">
                <button
                  class="btn btn-outline-info"
                  (click)="exportPayrollToCsv(batch)"
                  [disabled]="isExporting"
                >
                  <span *ngIf="!isExporting || exportingBatchId !== batch.id"
                    ><i class="ti ti-download"></i>Export</span
                  >
                  <span *ngIf="isExporting && exportingBatchId === batch.id"> Exporting...</span>
                </button>
                <button
                  (click)="openDeleteModal(deleteModal, batch?.id ?? '')"
                  class="btn btn-icon btn-danger"
                >
                  <i class="ti ti-trash"></i>
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the payroll batch, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <button class="btn btn-light me-3" data-bs-dismiss="modal" (click)="onClose()">Cancel</button>
      <button class="btn btn-danger" (click)="deletePayrollBatch(selectedPayrollBatchId)">
        Yes, Delete
      </button>
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->

<!-- Finalize Payroll Modal -->
<ng-template #finalizePayrollModal let-modal>
  <div class="modal-body">
    <h4 class="m-3 text-center">Confirm Payroll Payment</h4>
    <div>
      <form [formGroup]="payrollPaymentDetailsForm">
        <div class="form-group mb-3">
          <label for="dateOfPayment" class="form-label">Payment Date</label>
          <input
            appTrimInput
            type="date"
            class="form-control"
            id="dateOfPayment"
            formControlName="dateOfPayment"
          />
        </div>
        <div class="form-group mb-3">
          <label for="modeOfPayment" class="form-label">Mode of Payment</label>
          <select class="form-select" id="modeOfPayment" formControlName="modeOfPayment">
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="neft">NEFT</option>
            <option value="rtgs">RTGS</option>
            <option value="imps">IMPS</option>
            <option value="upi">UPI</option>
          </select>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-center">
      <button class="btn btn-light me-3" (click)="onClose()">Cancel</button>
      <button class="btn btn-primary" (click)="finalizePayroll(selectedPayrollBatchId)">
        Confirm Payment
      </button>
    </div>
  </div>
</ng-template>
<!-- /Finalize Payroll Modal -->
